import { jsx as _jsx } from "react/jsx-runtime";
import { IconPrimitive } from '#pplx/frontend/aether/primitives/IconPrimitive/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
export const MCPServerIcon = ({ serverName, iconUrl, size = 'md', border = false, padded = true, }) => {
    const { $t } = useIntl();
    if (iconUrl) {
        return (_jsx("img", { src: iconUrl, alt: $t({
                defaultMessage: '{serverName} Logo',
                description: 'Alt text for the MCP server icon image',
                id: 'a6425c23a0',
            }, { serverName }), className: classNames('object-contain', size === 'sm' && 'size-5', size === 'md' && 'size-12', size === 'md' && !border && padded && 'p-1', border && 'ring-soft rounded-md ring-1') }));
    }
    return (_jsx(IconPrimitive, { icon: $icon('box'), className: classNames(size === 'sm' && 'size-4', size === 'md' && 'size-12', size === 'md' && padded && 'p-1', border && 'ring-soft rounded-md ring-1') }));
};
//# sourceMappingURL=MCPServerIcon.js.map